export default __webpack_public_path__ + "../images/Flag_of_Europe.png";